var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8757 11.2983V6.54575H0.276367V4.69358H1.8757V3.32767C1.8757 1.74253 2.84385 0.879395 4.2579 0.879395C4.93524 0.879395 5.51739 0.929824 5.68704 0.952365V2.60892L4.70632 2.60937C3.93728 2.60937 3.78837 2.97481 3.78837 3.51106V4.69358H5.62246L5.38366 6.54575H3.78837V11.2983H1.8757Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.48e43b30b5e2e9462abbd3695a78f568.svg";
export { ForwardRef as ReactComponent };